export default [
  {
    path: "/wt-get-coupons-activity/:code",
    name: "GetCouponsActivity",
    meta: {
      title: " ",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "get-coupons" */ "@/views/get-coupons/GetCouponsActivity.vue"
      )
  },
  {
    path: "/wt-new-user-activity/:code",
    name: "NewUserActivity",
    meta: {
      title: " ",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "get-coupons" */ "@/views/get-coupons/NewUserActivity.vue"
      )
  }
];
